import React from 'react';
import { diasRestantes } from './regras';

// Aprovador: pendentes para avaliar. Vendedor: as solicitações dele, com status e prazo.
export default function ListaSolicitacoes({ solicitacoes, usuario, modoAprovador, podeAvaliar, onAvaliar, onProrrogar, onAbrirCurso }) {
  const lista = modoAprovador
    ? solicitacoes.filter(s => s.status === 'pendente')
    : solicitacoes.filter(s => String(s.id_vendedor_solicitante) === String(usuario.id));

  if (!lista.length) {
    return (
      <div className="cx-lista-sol">
        <div className="cx-vazio-lista">{modoAprovador ? 'Nenhuma solicitação aguardando avaliação.' : 'Você ainda não pediu liberação de nenhuma turma.'}</div>
      </div>
    );
  }

  return (
    <div className="cx-lista-sol">
      {lista.map(s => {
        const turma = s.ano_atendimento + (s.semestre_atendimento ? `/${s.semestre_atendimento}` : '');
        let situacao;
        let acao = null;
        if (s.status === 'pendente') {
          situacao = <span className="cx-selo cx-aviso">{modoAprovador ? 'Aguardando avaliação' : 'Em análise'}</span>;
          if (podeAvaliar) acao = <button type="button" className="cx-btn cx-aviso" onClick={() => onAvaliar(s)}>Avaliar</button>;
        } else if (s.status === 'aprovado') {
          const dias = s.prazo_fim ? diasRestantes(s.prazo_fim) : null;
          situacao = (
            <span className={`cx-selo ${dias != null && dias <= 2 ? 'cx-aviso' : 'cx-fec'}`}>
              Aprovada{dias != null ? ` · ${dias < 0 ? 'prazo vencido' : `${dias} ${dias === 1 ? 'dia' : 'dias'}`}` : ''}
            </span>
          );
          if (dias != null && dias <= 2 && !s.prorrogacao_usada) {
            acao = <button type="button" className="cx-btn cx-mini" onClick={() => onProrrogar(s)}>Prorrogar +5d</button>;
          }
        } else if (s.status === 'rejeitado') {
          situacao = <span className="cx-selo cx-per" title={s.justificativa || ''}>Recusada</span>;
        } else if (s.status === 'vencido') {
          situacao = <span className="cx-selo cx-sem">Prazo vencido</span>;
        } else {
          situacao = <span className="cx-selo cx-sem">{s.status}</span>;
        }

        return (
          <div className="cx-sol" key={s.id}>
            <div style={{ minWidth: 0 }}>
              <button type="button" className="cx-link" onClick={() => onAbrirCurso(s)}>{s.nome_curso} · {s.nome_instituicao}</button>
              <div className="cx-sub">
                Pedido por {s.nome_vendedor_solicitante} em {new Date(s.data_solicitacao).toLocaleString('pt-BR')}
              </div>
            </div>
            <div className="cx-num"><b>{turma}</b></div>
            <div className="cx-motivo" title={s.motivo || ''}>{s.motivo || '—'}</div>
            <div>{situacao}</div>
            <div className="cx-acoes-sol">{acao}</div>
          </div>
        );
      })}
    </div>
  );
}
